export type ScriptTypeFilter = "all" | "automation" | "manual";

type StepGroupValue = boolean | number | string | null | undefined;

interface StepGroupCaseLike {
  isStepGroup?: StepGroupValue;
  is_step_group?: StepGroupValue;
}

export function isStepGroupCase(testCase: StepGroupCaseLike): boolean {
  const value = testCase.isStepGroup ?? testCase.is_step_group;
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "true" || normalized === "1";
  }
  return false;
}

/** Automation when a script type is recorded and is not MANUAL. Otherwise is_automated_script decides; null is manual. */
export function isAutomationCase(testCase: {
  isAutomatedScript?: boolean | null;
  is_automated_script?: boolean | null;
  scriptType?: string | null;
  script_type?: string | null;
  type?: string | number | null;
  isAutomated?: boolean | null;
  is_automated?: boolean | null;
}): boolean {
  if (!testCase) return false;
  const rawType = testCase.scriptType ?? testCase.script_type ?? testCase.type;
  const normalizedType = String(rawType ?? "").trim().toLowerCase();
  if (normalizedType.length > 0) {
    if (normalizedType.includes("auto")) return true;
    if (normalizedType.includes("man")) return false;
    return normalizedType !== "manual";
  }
  if (testCase.isAutomated === true || testCase.is_automated === true) return true;
  if (testCase.isAutomatedScript === true || testCase.is_automated_script === true) return true;
  return false;
}

export function matchesScriptType(
  testCase: {
    isAutomatedScript?: boolean | null;
    is_automated_script?: boolean | null;
    scriptType?: string | null;
    script_type?: string | null;
  },
  filter: ScriptTypeFilter,
): boolean {
  if (filter === "all") return true;

  const rawType = testCase.scriptType ?? testCase.script_type;
  const normalizedType = String(rawType ?? "").trim().toLowerCase();
  const isManual =
    normalizedType.length > 0
      ? normalizedType === "manual"
      : (testCase.isAutomatedScript ?? testCase.is_automated_script) === false;

  return filter === "manual" ? isManual : !isManual;
}
